<template>
	<div>
		<el-row class="search"><span>状态：</span><el-select filterable v-model="search.valid" placeholder="">
				<el-option v-for="(item, itemIndex) in statuslist" v-bind:key="itemIndex + 99" :label="item.name"
					:value="item.value"></el-option>
			</el-select>
			<span>场景：</span>
			<el-select filterable v-model="search.scene" placeholder="">
				<el-option v-for="(item, itemIndex) in scenelist" v-bind:key="itemIndex + 99" :label="item.name"
					:value="item.value"></el-option>
			</el-select>

			<el-button type="primary" @click="query" :loading="loading">
				查询
			</el-button>
			<el-button type="warning" @click="operate(1)">
				新增
			</el-button></el-row>
		<el-row>
			<el-table :data="datalist" style="width: 100%" v-loading="loading" height="60vh" stripe border>
				<el-table-column prop="name" label="名称"> </el-table-column>
				<el-table-column prop="bannerSwitchKey" label="配置key" />
				<el-table-column prop="scene" label="场景">
					<template slot-scope="scope">
						{{
							scenelist.filter(x => x.value == scope.row.scene)[0] &&
							scenelist.filter(x => x.value == scope.row.scene)[0].name
						}}
					</template>
				</el-table-column>
				<el-table-column prop="icon" label="图标">
					<template slot-scope="scope">
						<el-image style="width: 100px; height: auto" :src="scope.row.icon"
							:preview-src-list="[scope.row.icon]"></el-image>
					</template>
				</el-table-column>

				<el-table-column prop="link" label="链接地址">
				</el-table-column>
				<el-table-column prop="desc" label="描述"> </el-table-column>
				<el-table-column prop="valid" label="状态">
					<template slot-scope="scope">
						<el-button type="primary" @click="updownStatus(1, scope.row.id)" v-if="scope.row.valid == 0" size="mini">
							上架
						</el-button>
						<el-button type="danger" @click="updownStatus(0, scope.row.id)" v-if="scope.row.valid == 1" size="mini">
							下架
						</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="orderId" label="排序值">
				</el-table-column>
				<el-table-column label="跳转类型">
					<template slot-scope="scope">
						{{
							typelist.filter(
								(x) => x.value == scope.row.jumpPage
							)[0].name
						}}
					</template>
				</el-table-column>
				<el-table-column prop="startTime" label="上架时间">
				</el-table-column>
				<el-table-column prop="endTime" label="下架时间">
				</el-table-column>
				<el-table-column prop="mtime" label="修改时间">
				</el-table-column>
				<el-table-column prop="operator" label="操作人">
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="operate(2, scope.row)">编辑</el-button>
					</template></el-table-column>
			</el-table>
		</el-row>
		<el-row>
			<el-pagination :current-page.sync="pageInfo.page" layout="total, prev, pager, next" background
				@current-change="handleCurrentChange" :total="pageInfo.total" class="pagination" :page-size="30"></el-pagination>
		</el-row>
		<el-drawer :title="type === 2 ? '编辑' : '新增'" size="40%" :visible.sync="drawer" direction="rtl"
			:before-close="handleClose">
			<div class="item">
				<span>名字：</span><el-input type="text" v-model="data.name" />
			</div>
			<div class="item">
				<span>配置key：</span><el-input type="text" v-model="data.bannerSwitchKey" />
			</div>
			<div class="item">
				<span>场景：</span><el-select filterable v-model="data.scene" placeholder="">
					<el-option v-for="(item, itemIndex) in scenelist" :key="itemIndex + 99" :label="item.name"
						:value="item.value"></el-option>
				</el-select>
			</div>
			<div class="item">
				<span>图片：</span><el-upload class="avatar-uploader" action="" :auto-upload="false" :show-file-list="false"
					:on-change="changfile" ref="upload">
					<el-image v-if="data.icon !== ''" style="width: auto; height: 178px" :src="data.icon"
						fit="scale-down"></el-image>
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</div>
			<div class="item">
				<span>链接地址：</span><el-input type="text" v-model="data.link" />
			</div>
			<div class="item">
				<span>描述：</span><el-input type="text" v-model="data.desc" />
			</div>
			<div class="item">
				<span>状态：</span><el-switch v-model="data.valid" active-color="#13ce66" inactive-color="#ff4949" active-text="上架"
					inactive-text="下架" :active-value="1" :inactive-value="0">
				</el-switch>
			</div>
			<div class="item">
				<span>排序值：</span><el-input type="number" v-model="data.orderId" />
			</div>
			<div class="item">
				<span>跳转类型：</span><el-select filterable v-model="data.jumpPage" placeholder="">
					<el-option v-for="(item, itemIndex) in typelist.slice(1)" v-bind:key="itemIndex + 99" :label="item.name"
						:value="item.value"></el-option>
				</el-select>
			</div>
			<div class="item">
				<span>上下架时间：</span><el-date-picker v-model="data.updownDate" type="datetimerange" align="right" unlink-panels
					range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
				</el-date-picker>
			</div>
			<div class="item">
				<el-button type="primary" @click="operate(3)" v-if="type == 1">新增</el-button>
				<el-button type="primary" @click="operate(4)" v-if="type == 2">编辑</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { timestampToTime } from '@/utils/common'
export default {
	data() {
		return {
			typelist: [],
			scenelist: [],
			statuslist: [
				{ name: '上架', value: 1 },
				{ name: '下架', value: 0 },
			],
			datalist: [],
			loading: false,
			drawer: false,
			type: 1,
			search: {
				valid: 1,
				scene: 0,
			},
			pageInfo: {
				page: 1,
				total: 0,
			},
			data: {
				id: '',
				name: '',
				bannerSwitchKey: '',
				icon: '',
				link: '',
				desc: '',
				scene: 0,
				valid: 0,
				orderId: 0,
				jumpPage: '',
				updownDate: [],
				operator: this.$store.getters.username,
			},
		}
	},
	methods: {
		async typeQuery() {
			const { data: res } = await this.$axios({
				type: 'GET',
				url: this.$store.getters.path.banner_type_query,
				withCredentials: true,
				params: {
					username: this.$store.getters.username,
					token: this.$store.getters.token,
				},
			})
			this.typelist = res.data
			this.typelist.unshift({ name: 'all', value: 0 })
		},
		async query() {
			this.loading = true
			const { data: res } = await this.$axios({
				method: 'get',
				url:
					this.$store.getters.path.banner_query +
					'?username=' +
					this.$store.getters.username +
					'&token=' +
					this.$store.getters.token,
				withCredentials: true,
				params: {
					valid: this.search.valid,
					scene: this.search.scene,
					page: this.pageInfo.page,
				},
			})
			this.loading = false
			if (res.code != 0) return this.$message.error(res.msg)
			this.datalist = res.data.data
			this.pageInfo.total = res.data.total
			this.datalist.map((item) => {
				if (item.startTime !== 0)
					item.startTime = timestampToTime(item.startTime)
				if (item.endTime !== 0)
					item.endTime = timestampToTime(item.endTime)
				if (item.mtime !== 0) item.mtime = timestampToTime(item.mtime)
			})
			this.$message.success('查询成功')
		},
		async updownStatus(type, id) {
			this.$confirm(type == 0 ? '确认下架' : '确认上架', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(async () => {
					const { data: res } = await this.$axios(
						this.$store.getters.path.banner_upp +
						'?username=' +
						this.$store.getters.username +
						'&token=' +
						this.$store.getters.token +
						'&id=' +
						id +
						'&valid=' +
						type,
						{}
					)
					if (res.code !== 0) return this.$message.error('操作失败')
					this.$message.success('操作成功')
					this.query()
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作',
					})
				})
		},
		async sceneQuery() {
			const { data: res } = await this.$axios({
				type: 'GET',
				url: this.$store.getters.path.generate_scene_query,
				withCredentials: true,
				params: {
					username: this.$store.getters.username,
					token: this.$store.getters.token
				}
			})
			this.scenelist = res.data
			this.scenelist.unshift({ name: 'all', value: 0 })
		},
		handleCurrentChange(num) {
			this.pageInfo.page = num
			this.query()
		},
		async operate(type, obj) {
			if (type == 1) {
				this.type = type
				this.drawer = true
			} else if (type == 2) {
				this.type = type
				this.drawer = true
				obj.scene = Number(obj.scene)
				this.data = {
					id: obj.id,
					name: obj.name,
					bannerSwitchKey: obj.bannerSwitchKey,
					icon: obj.icon,
					link: obj.link,
					desc: obj.desc,
					scene: obj.scene,
					valid: obj.valid,
					orderId: obj.orderId,
					jumpPage: obj.jumpPage,
					updownDate: [],
					operator: this.$store.getters.username,
				}

				// console.log(obj.scene);
				if (obj.startTime !== 0)
					this.data.updownDate = [obj.startTime, obj.endTime]
			} else if (type == 3) {
				const { data: res } = await this.$axios.post(
					this.$store.getters.path.banner_add +
					'?username=' +
					this.$store.getters.username +
					'&token=' +
					this.$store.getters.token,
					{
						...this.data,
						startTime:
							Date.parse(new Date(this.data.updownDate[0])) /
							1000,
						endTime:
							Date.parse(new Date(this.data.updownDate[1])) /
							1000,
					}
				)
				if (res.code != 0) return this.$message(res.msg)
				this.$message.success('操作成功')
				this.query()
				this.handleClose()
			} else if (type == 4) {
				const { data: res } = await this.$axios.post(
					this.$store.getters.path.banner_edit +
					'?username=' +
					this.$store.getters.username +
					'&token=' +
					this.$store.getters.token,
					{
						...this.data,
						startTime:
							Date.parse(new Date(this.data.updownDate[0])) /
							1000,
						endTime:
							Date.parse(new Date(this.data.updownDate[1])) /
							1000,
					}
				)
				if (res.code != 0) return this.$message(res.msg)
				this.$message.success('操作成功')
				this.query()
				this.handleClose()
			}
		},
		async changfile(file) {
			this.dwnload = true
			const formdata = new FormData()
			formdata.append('file', file.raw)
			formdata.append('cover', 0)
			formdata.append('dir', 'banner/host/')
			const { data: res } = await this.$axios.post(
				this.$store.getters.path.hostmgr_upload +
				'?username=' +
				this.$store.getters.username +
				'&token=' +
				this.$store.getters.token,
				formdata
			)
			this.dwnload = false
			if (res.code !== 0) {
				this.$refs.upload.clearFiles()
				return this.$message.error('文件上传失败请重新选择文件上传')
			}
			this.data.icon = res.data
		},
		handleClose() {
			this.drawer = false
			this.data = {
				id: '',
				name: '',
				bannerSwitchKey: '',
				icon: '',
				link: '',
				desc: '',
				scene: 0,
				valid: 0,
				orderId: 0,
				jumpPage: '',
				updownDate: [],
				operator: this.$store.getters.username,
			}
		},
	},
	created() {
		this.typeQuery()
		this.sceneQuery()
		this.query()
	},
}
</script>
<style lang="scss" scoped>
.search {
	display: flex;
	align-items: center;

	.el-input {
		max-width: 250px;
	}

	>* {
		margin: 0 3px;
	}
}

.item {
	display: flex;
	align-items: center;
	padding: 5px 15px;

	span {
		white-space: nowrap;
		padding: 0 5px;
	}
}
</style>
